import { useCallback } from "react";
import { Node, NodeProps, useInternalNode } from "@xyflow/react";
import { useSetAtom } from "jotai";
import { useAtomCallback } from "jotai/utils";
import {
  nodesAtom,
  removeEphemeralEmbedNodesSetter,
} from "@zapier/canvas-state";
import { uuid } from "@zapier/canvas-state/src/utils";

import { EmbedNodeLinkInput } from "../EmbedNode/EmbedNodeLinkInput";

type EmbedEphemeralNodeData = Record<string, never>;

export function EmbedEphemeralNode(
  props: NodeProps<Node<EmbedEphemeralNodeData>>,
) {
  const { id } = props;
  const internalNode = useInternalNode(id);

  const removeEphemeralEmbedNodes = useSetAtom(removeEphemeralEmbedNodesSetter);

  const handleCreate = useAtomCallback(
    useCallback(
      (get, set, link: string) => {
        if (!internalNode) return;

        const newEmbedNode = {
          id: uuid(),
          type: "embed" as const,
          position: internalNode.position,
          data: {
            link,
            attributionSourceType: "MANUAL" as const,
          },
          selected: true,
        };

        // Replace ephemeral node with real embed node and deselect others
        // Don't save to BE since EmbedNodeContent will save once we have measured width and height
        set(nodesAtom, (prevNodes) =>
          prevNodes.map((node) =>
            node.id === id ? newEmbedNode : { ...node, selected: false },
          ),
        );
      },
      [id, internalNode],
    ),
  );

  return (
    <EmbedNodeLinkInput
      onClose={removeEphemeralEmbedNodes}
      onCreate={handleCreate}
    />
  );
}
